import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class FormBuilderUDFService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  saveForm(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/saveForm', data);
  }

  getFormByModulePage(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/getFormByModulePage', data);
  }

  getDataFromAPI(data: any, APIURL: string, requestType: string): Observable<any> {
    // URLs starting with 'api/' are external API paths stored in old form JSON.
    // Route through ExternalProxy so the backend can look up the auth config and forward correctly.
    if (/^api\//i.test(APIURL)) {
      return this.http.get<any>(`${this.baseUrl}FormBuilder/ExternalProxy?apiUrl=${encodeURIComponent(APIURL)}`);
    }
    switch (requestType.toLowerCase()) {
      case 'post':
        return this.http.post<any>(this.baseUrl + APIURL, data);
      case 'put':
        return this.http.put<any>(this.baseUrl + APIURL, data);
      case 'delete':
        return this.http.delete<any>(this.baseUrl + APIURL, { body: data });
      case 'patch':
        return this.http.patch<any>(this.baseUrl + APIURL, data);
      case 'get':
      default:
        return this.http.get<any>(this.baseUrl + APIURL);
    }
  }

  // Secure proxy: token stays on backend; frontend only sends apiDirectoryId + params
  callExternalAPI(apiDirectoryId: number, params: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/CallExternalAPI', { apiDirectoryId, params });
  }

  saveFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/saveFormData', data);
  }

  fetchFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/fetchFormData', data);
  }
  getForms(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'FormBuilder/getForms');
  }

  getFormStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'FormBuilder/getFormStaus');
  }

  createDynamicTable(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/CreateDynamicTable', data);
  }

  AprrovedAndGetFormDetail(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/ApprovedAndGetFormDetail', data);
  }

  getFormDetail(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/getFormDetail', data);
  }

  //  dynamic table api and changes

  InsertFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/InsertFormData', data);
  }
  updateFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/UpdateFormData', data);
  }

  getTableName(formId: any): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}FormBuilder/getTableName?formId=${formId}`);
  }

  DeleteFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/DeleteFormData', data);
  }

  GetFormDataById(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/GetFormDataById', data);
  }

  GetFormListData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/GetFormListData', data);
  }

  GetFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/GetFormData', data);
  }

}